import { render, staticRenderFns } from "./WorkflowROITable.vue?vue&type=template&id=5057e39a&scoped=true&"
import script from "./WorkflowROITable.vue?vue&type=script&lang=js&"
export * from "./WorkflowROITable.vue?vue&type=script&lang=js&"
import style0 from "./WorkflowROITable.vue?vue&type=style&index=0&id=5057e39a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5057e39a",
  null
  
)

export default component.exports